// import request from '../../request'
import listPage from '../list_page'

export default listPage('/users', {
})
